import * as React from "react"

/**
 * The registry hook, verbatim, because `ui/sidebar.tsx` imports it.
 *
 * It is **not** the app's viewport switch. The shell decides which navigation
 * exists from `(min-width: 1024px)` in `src/routes/Shell.tsx`, and only mounts
 * the sidebar above that line — so `useIsMobile` is always false wherever it is
 * consulted here, and the sidebar's mobile <Sheet> branch never runs. Left as
 * the registry wrote it so the file can be re-added from the registry without a
 * diff to reconcile.
 */
const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    mql.addEventListener("change", onChange)
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return !!isMobile
}
